export const PRODUCT_TYPES_DEMO = [
  { id: 'pt_01', name: 'Apparel',     slug: 'apparel',     attributes: ['size', 'color'], productCount: 38 },
  { id: 'pt_02', name: 'Accessory',   slug: 'accessory',   attributes: ['color'],          productCount: 7 },
  { id: 'pt_03', name: 'Digital',     slug: 'digital',     attributes: [],                 productCount: 0 },
]
